var BetsFetchDefaultPaths;
(function (BetsFetchDefaultPaths) {
    BetsFetchDefaultPaths["FirstStep"] = "/betsByDay";
    BetsFetchDefaultPaths["SecondStep"] = "";
    BetsFetchDefaultPaths["ThirdStep"] = "";
    BetsFetchDefaultPaths["TopWinners"] = "/topWinners";
})(BetsFetchDefaultPaths || (BetsFetchDefaultPaths = {}));
var BetsFetchDefaultParamNames;
(function (BetsFetchDefaultParamNames) {
    BetsFetchDefaultParamNames["Id"] = "betId";
})(BetsFetchDefaultParamNames || (BetsFetchDefaultParamNames = {}));

export { BetsFetchDefaultParamNames, BetsFetchDefaultPaths };
